module.exports = __webpack_public_path__ + "img/media-folder.b092337d.svg";